import { useEffect } from "react";
import { useTheme } from "next-themes";

/**
 * Keeps the <meta name="theme-color"> tag in sync with the resolved theme.
 * This affects the iOS / Android browser address-bar tint and the PWA
 * status bar in standalone mode. Runs after hydration; the inline pre-paint
 * script in index.html handles the very first paint.
 */
export function ThemeMetaSync() {
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    const colorDark = "#0e1620";   // matches --background dark (215 25% 7%)
    const colorLight = "#fafbfd";  // matches --background light (210 40% 99%)
    const color = resolvedTheme === "dark" ? colorDark : colorLight;

    let meta = document.querySelector('meta[name="theme-color"]:not([media])') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "theme-color";
      document.head.appendChild(meta);
    }
    meta.content = color;
  }, [resolvedTheme]);

  return null;
}

export default ThemeMetaSync;
